import { handleActions } from "redux-actions";
import { INVENTORY_DATA } from "constants/action-types";
import { initialUpdateState, IUpdateStoreState, updateProgressActions } from "./base-reducers";
import { uploadActions } from "./base-upload-reducers";

export const inventoryDataUpload = uploadActions(INVENTORY_DATA);

export interface IInventoryDataState extends IUpdateStoreState<null> {
    isLoading: boolean;
    link: string;
    message: string;
    uploadFinished: boolean;
}

export const inventoryData = handleActions<IInventoryDataState>(
    {
        ...updateProgressActions(INVENTORY_DATA.UPLOAD_NON_VETL),
        [INVENTORY_DATA.UPDATE]: (
            state: IInventoryDataState,
            { payload }: { payload: Partial<IInventoryDataState> }
        ) => ({
            ...state,
            ...payload,
        }),
    } as any,
    {
        ...initialUpdateState,
        isLoading: false,
        link: null,
        message: null,
        uploadFinished: false,
    }
);
